export default {
  name: "Systeem instellingen",
}
